import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, pure, withProps } from 'recompose';
import Carousel from '../Carousel';

import {
  StyledGallery,
  StyledHeaderGallery,
  StyledLogo,
  Styledclose,
  StyledHeaderContent,
  StyledNavigation,
  StyledElements,
  StyledBoxContent,
  StyledBoxClose,
  StyledBoxNavigation,
  StyledItems,
  StyledBoxTextGallery,
  StyledArrowRight,
  StyledArrowLeft,
  StyledImg
} from './style';
import Image from '../Image';

import Logo from '../../../../assets/images/logo.svg';
import { Close } from '../../../../assets/images/index';
import { totalElements } from '../../../utils/resources';

const GalleryPager = ({ activePage, onClick, elements }) => (
  <StyledBoxNavigation>
    <StyledNavigation>
      {elements.map((el, i) => (
        <StyledElements
          id="pager"
          key={el}
          activePage={i === activePage}
          onClick={() => onClick(i)}
        />
      ))}
    </StyledNavigation>
  </StyledBoxNavigation>
);
const galleryPager = compose(
  withProps(({ pagesNumber }) => ({ elements: totalElements(pagesNumber) })),
  pure
)(GalleryPager);

const GalleryPreviousButton = props => <StyledArrowLeft {...props} />;
const GalleryNextButton = props => <StyledArrowRight {...props} />;

const GalleryFullScreen = ({
  modeMobile,
  onClose,
  onTapMobile,
  title,
  subtitle,
  author,
  images
}) => (
  <StyledGallery>
    <StyledHeaderGallery>
      <StyledHeaderContent>
        <StyledLogo color="light" svg={Logo} hover />
        <StyledBoxClose modeMobile={modeMobile} onClick={onClose}>
          <Styledclose color="light" svg={Close} hover />
        </StyledBoxClose>
      </StyledHeaderContent>
    </StyledHeaderGallery>
    <StyledBoxContent modeMobile={modeMobile} onClick={onTapMobile}>
      <Carousel
        previousButton={GalleryPreviousButton}
        nextButton={GalleryNextButton}
        paginator={galleryPager}
      >
        {images.map(image => (
          <StyledItems key={image}>
            <StyledBoxTextGallery
              modeMobile={modeMobile}
              title={title}
              paragraph={subtitle}
              author={author}
            />
            <StyledImg>
              <Image path={image} defaultCrop={{ width: 1239, height: 697 }} />
            </StyledImg>
          </StyledItems>
        ))}
      </Carousel>
    </StyledBoxContent>
  </StyledGallery>
);

GalleryFullScreen.propTypes = {
  modeMobile: PropTypes.bool,
  images: PropTypes.arrayOf(PropTypes.string)
};
export default compose(
  withState('modeMobile', 'setModeMobile', false),
  withHandlers({
    onTapMobile: ({ setModeMobile, modeMobile }) => event => {
      if (event.target.id !== 'pager') {
        setModeMobile(!modeMobile);
      }
    }
  })
)(GalleryFullScreen);
